import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import AnnouncementConsentActionButtons from './AnnouncementConsentActionButtons';

const styles = () => ({
  announcementPriorityPinned: {
    border: '2px solid #ffca28'
  },
  consentWrapper: {
    marginTop: 20,
    padding: 20,
    backgroundColor: '#fafafa',
    '& h4': {
      marginTop: 0,
    },
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};

class AnnouncementConsent extends React.Component {
  render() {
    const {
      classes,
      t,
      announcement,
      selectedPupil,
    } = this.props;

    if (announcement.requires_consent === 'no') {
      return null;
    }

    if (appType === 'student') {
      if (announcement.allow_consent === 'no') {
        return null;
      }

      return (
        <div className={`announcement-consent ${classes.consentWrapper}`}>
          <p>{t('This announcement requires consent from your parent/guardian')}</p>
        </div>
      );
    }

    if (announcement.allow_consent === 'no') {
      return (
        <div className={`announcement-consent ${classes.consentWrapper}`}>
          <p>{t('Consent options have been disabled by your school')}</p>
        </div>
      );
    }

    if (!selectedPupil) {
      return (
        <div className={`announcement-consent ${classes.consentWrapper}`}>
          <p>{t('This announcement requests your consent. Please review your decision below, or navigate to each associated pupil\'s announcement tab.')}</p>
          {announcement.pupil_consents.map((entry) => {
            return (
              <div key={entry.pupil.id}>
                <h4>{entry.pupil.first_name + ' ' + entry.pupil.last_name }</h4>
                {!entry.can_change_consent && (
                  <p>
                    <span>{t('Another parent/carer ({parent_name}) has already responded to this consent request.')
                      .replace('{parent_name}', entry.consent.parent_name)} </span>
                    <span>
                      {entry.consent?.consent_given === 'yes' && t('They have given the consent.')}
                      {entry.consent?.consent_given === 'no' && t('They have not given the consent.')}
                    </span>
                  </p>
                )}
                {entry.can_change_consent && (
                  <AnnouncementConsentActionButtons
                    pupilId={entry.pupil.id}
                    announcement={announcement}
                    consent={entry.consent}
                  />
                )}
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <div className={`announcement-consent ${classes.consentWrapper}`}>
        <h4>{t('Consent')}</h4>
        {!announcement.can_change_consent && (
          <p>
            <span>{t('Another parent/carer ({parent_name}) has already responded to this consent request.')
              .replace('{parent_name}', announcement.consent.parent_name)} </span>
            <span>
              {announcement.consent?.consent_given === 'yes' && t('They have given the consent.')}
              {announcement.consent?.consent_given === 'no' && t('They have not given the consent.')}
            </span>
          </p>
        )}
        {announcement.can_change_consent && (
          <AnnouncementConsentActionButtons
            pupilId={selectedPupil.id}
            announcement={announcement}
            consent={announcement.consent}
          />
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(AnnouncementConsent)))
);
